import React from "react";
import "./../styles/sections.css"; // Assuming shared styles
import Header from "./Header";
import Footer from "./Footer";

const PrivacyPolicy = ({ translations, language, setLanguage }) => {
  return (
    <>
      <Header language={language} setLanguage={setLanguage} />
      <main className="privacy-policy-container">
        <section className="privacy-policy-content">
          <h1>{translations.privacy_policy_title}</h1>
          <p>{translations.privacy_policy_last_updated}</p>

          <p>{translations.privacy_policy_intro}</p>

          <h2>{translations.privacy_policy_section_1_title}</h2>
          <h3>{translations.privacy_policy_section_1_subtitle_a}</h3>
          <p>{translations.privacy_policy_section_1_content_a}</p>
          <ul>
            <li>{translations.privacy_policy_section_1_content_a_item_1}</li>
            <li>{translations.privacy_policy_section_1_content_a_item_2}</li>
            <li>{translations.privacy_policy_section_1_content_a_item_3}</li>
            <li>{translations.privacy_policy_section_1_content_a_item_4}</li>
          </ul>

          <h3>{translations.privacy_policy_section_1_subtitle_b}</h3>
          <p>{translations.privacy_policy_section_1_content_b}</p>

          <h2>{translations.privacy_policy_section_2_title}</h2>
          <p>{translations.privacy_policy_section_2_content}</p>
          <ul>
            <li>{translations.privacy_policy_section_2_content_item_1}</li>
            <li>{translations.privacy_policy_section_2_content_item_2}</li>
            <li>{translations.privacy_policy_section_2_content_item_3}</li>
          </ul>

          <h2>{translations.privacy_policy_section_3_title}</h2>
          <p>{translations.privacy_policy_section_3_content}</p>
          <ul>
            <li>{translations.privacy_policy_section_3_content_item_1}</li>
            <li>{translations.privacy_policy_section_3_content_item_2}</li>
            <li>{translations.privacy_policy_section_3_content_item_3}</li>
            <li>{translations.privacy_policy_section_3_content_item_4}</li>
          </ul>

          <h2>{translations.privacy_policy_section_4_title}</h2>
          <p>{translations.privacy_policy_section_4_content}</p>

          <h2>{translations.privacy_policy_section_5_title}</h2>
          <p>{translations.privacy_policy_section_5_content}</p>
          <ul>
            <li>{translations.privacy_policy_section_5_content_item_1}</li>
            <li>{translations.privacy_policy_section_5_content_item_2}</li>
            <li>{translations.privacy_policy_section_5_content_item_3}</li>
          </ul>

          <h2>{translations.privacy_policy_section_6_title}</h2>
          <p>{translations.privacy_policy_section_6_content}</p>
          <ul>
            <li>{translations.privacy_policy_section_6_content_item_1}</li>
            <li>{translations.privacy_policy_section_6_content_item_2}</li>
          </ul>

          <h2>{translations.privacy_policy_section_7_title}</h2>
          <p>{translations.privacy_policy_section_7_content}</p>
          <ul>
            <li>{translations.privacy_policy_section_7_content_item_1}</li>
            <li>{translations.privacy_policy_section_7_content_item_2}</li>
            <li>{translations.privacy_policy_section_7_content_item_3}</li>
          </ul>

          <h2>{translations.privacy_policy_section_8_title}</h2>
          <p>
            {translations.privacy_policy_section_8_content}
            <a href="https://www.v-assistant.online/contact" target="_blank" rel="noopener noreferrer">
              https://www.v-assistant.online/contact
            </a>
          </p>

          <h2>{translations.privacy_policy_section_9_title}</h2>
          <p>{translations.privacy_policy_section_9_content}</p>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;